import React from 'react';
import { Outlet } from 'react-router-dom';

const Layout3 = () => {
  return (
    <div>
      <Outlet/>
    </div>
  );
}

export default Layout3;
